import React from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

const AdminReferral = () => {
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-12 col-12">
                <div className="card rounded-1">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">Referral Details</h5>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row mb-3">
                      <p>
                        This information will be used as referral system. in
                        order to disable the referral system. please choose
                        status to deactive.
                      </p>
                    </div>
                    <form action="#" className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label for="rtitle">Referral Title :</label>
                          <input
                            type="text"
                            className="form-control"
                            id="rtitle"
                            placeholder="Refer a friend and get $100 wallet amount"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label for="storeDesc">Referral Message:</label>
                          <textarea
                            className="form-control"
                            id="storeDesc"
                            rows="3"
                            placeholder="invite friends to Ultimate Grocery and get $100 when your friend signup with us"
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label for="Amount ">Amount </label>
                        <div className="form-group">
                          <input
                            type="number"
                            className="form-control"
                            id="Amount "
                            placeholder="100"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label for="Limit">Limit</label>
                        <div className="form-group">
                          <input
                            type="number"
                            className="form-control"
                            id="Limit"
                            placeholder="100"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label for="selectCity">Who Received</label>
                          <select className="form-select" id="selectCity">
                            <option value="1"> Invitee </option>
                            <option value="2"> Who Redeem </option>
                            <option value="3">
                              {" "}
                              Both Invitee & Who Redeem{" "}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label for="selectCity">Status</label>
                          <select className="form-select" id="selectCity">
                            <option value="1"> Active </option>
                            <option value="2"> Deactive </option>
                          </select>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <button type="submit" className="btn btn-primary">
                          {" "}
                          Update Referral Program{" "}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AdminReferral;
